import React from "react";
import { Form, TextField, Button } from "@vitalsource/vstui";
import styled, { withTheme } from "styled-components";
import { Search, XSmall } from "@vitalsource/vstui-icons";
import { cloud } from "@vitalsource/vstui/colors";
import { styledMedia } from "../../components/mediaquery/breakpoints";
import { t } from "../../core/translate";

const SearchFieldContainer = styled.div`
  position: relative;
`;

const SearchFieldForm = styled(Form)`
  &:focus-within {
    svg {
      fill: ${props => props.theme.color.primary.getShade(7)};
    }
  }
  div {
    margin-left: auto;
    margin-right: auto;
    input {
      border: 1px solid ${cloud.getShade(5)};
      border-radius: 24px;
      width: 100%;
      padding: 0 35px;
      ${styledMedia.small`
        padding: 0 45px;
      `}
      &:focus {
        box-shadow: 0 0 0 1px ${props => props.theme.color.primary.getShade(7)};
        border-color: ${props => props.theme.color.primary.getShade(7)};
      }
    }
  }
`;

const SearchIcon = styled(Search)`
  position: absolute;
  top: 33px;
  left: 40px;
  fill: ${cloud.getShade(5)};
  ${styledMedia.small`
    left: 20px;
  `}
`;

const CleanSearchButton = styled(Button)`
  position: absolute;
  top: 33px;
  right: 45px;
  svg {
    fill: ${cloud.getShade(5)};
  }
  ${styledMedia.small`
    right: 20px;
  `}
`;

class SearchField extends React.Component {
  render() {
    const { onSubmit, onChange, clearInput, ...inputProps } = this.props;
    return (
      <SearchFieldContainer>
        <SearchFieldForm
          onSubmit={e => {
            e.preventDefault();
            onSubmit(e, this.searchField.value);
          }}
        >
          <SearchIcon />
          <TextField
            {...inputProps}
            type="search"
            onChange={e => onChange(e, this.searchField.value)}
            nativeFormControlRef={x => (this.searchField = x)}
          />
        </SearchFieldForm>
        <CleanSearchButton
          onClick={clearInput}
          naked
          inline
          iconStart={<XSmall />}
          label={t("input.clear", "clear")}
        />
      </SearchFieldContainer>
    );
  }
}

export default withTheme(SearchField);
